var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlrLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.87,
    height: 51.206,
    viewBox: "0 0 61.87 51.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-2688.011 1514.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13322",
    transform: "translate(2688.011 -1514.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13300",
    d: "M1091.5,242.706l-16.977,17.065h-14.4L1046.4,273.489h16.781v17.065l17.066-17.065h14.306l13.717-13.717H1091.5Zm-3.456,8.287v8.778h-8.788Zm-26.541,12.234h9.573l-6.814,6.8H1054.7Zm14.5,0h9.573l-6.913,6.8H1069.1Zm14.4,0h9.573l-6.814,6.8h-9.564Zm-14.994,10.163-8.778,8.778v-8.68Z",
    transform: "translate(-1046.403 -242.706)",
    fill: "#687088",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13304",
    d: "M1432.956,712.935v10.153h2.867c3.056,0,5.823-.981,5.823-5.027,0-4.147-2.767-5.125-5.823-5.125Zm2.072,1.571h1.188a3.509,3.509,0,0,1,0,7.011h-1.188Z",
    transform: "translate(-1399.208 -671.882)",
    fill: "#687088",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13312",
    d: "M1648.644,712.693c-.239-.007-.473.007-.707.02h-3.653v10.153h2.072v-3.751h1.483c.882,0,1.182.3,1.473,1.09l1.1,2.661h2.465l-1.679-3.545a2.049,2.049,0,0,0-.894-1.09,2.391,2.391,0,0,0,1.679-2.464C1651.982,713.347,1650.315,712.739,1648.644,712.693Zm-2.288,1.689h1.385c1.082,0,1.971.3,2.062,1.385v.285c-.091,1.091-.98,1.385-2.062,1.385h-1.385Z",
    transform: "translate(-1592.086 -671.659)",
    fill: "#687088",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13308",
    d: "M8111.888-3448.989h6.02v-1.673h-3.955v-8.485h-2.064Z",
    transform: "translate(-8067.381 3500.195)",
    fill: "#687088",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlrLogo);
export default __webpack_public_path__ + "static/media/dlr-logo.70db39cb3c57003f077e2049115c3eb9.svg";
export { ForwardRef as ReactComponent };